var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTv(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5104 25.3728H2.39048C2.23487 25.3728 2.10873 25.2467 2.10873 25.0911V22.2735H34.7921V25.0911C34.7921 25.2467 34.666 25.3728 34.5104 25.3728H34.5104ZM22.1132 34.389H14.7876V27.0634H22.1132V34.389ZM2.39048 1.70554H34.5104C34.666 1.70554 34.7921 1.83169 34.7921 1.98729V20.583H2.10872V1.98729C2.10872 1.83168 2.23487 1.70554 2.39047 1.70554H2.39048ZM34.5104 0.0150146H2.39048C1.30122 0.0150146 0.418213 0.898035 0.418213 1.98729V25.0911C0.418213 26.1803 1.30123 27.0634 2.39049 27.0634H13.0971V34.389H8.58906C8.12224 34.389 7.7438 34.7674 7.7438 35.2342C7.7438 35.701 8.12224 36.0795 8.58906 36.0795H28.3118C28.7786 36.0795 29.1571 35.701 29.1571 35.2342C29.1571 34.7674 28.7786 34.389 28.3118 34.389H23.8038V27.0634H34.5104C35.5997 27.0634 36.4827 26.1804 36.4827 25.0911V1.9873C36.4827 0.898045 35.5996 0.0150346 34.5104 0.0150346L34.5104 0.0150146Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTv);
export default __webpack_public_path__ + "static/media/tv.fe1f46b1300326ca5c5b9a16ea04317b.svg";
export { ForwardRef as ReactComponent };